import TreasuryMovementList from "../components/treasury/TreasuryMovementList";

const TreasuryMovementsPage = () => {
  return (
    <>
      <TreasuryMovementList />
    </>
  );
};

export default TreasuryMovementsPage;
